import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";

export const channelReducer = (
  state: LoanState,
  action: PayloadAction<string>,
) => {
  state.channel = action.payload;
};
